export const REQUEST_IDENTITY_PROFILE = "REQUEST_IDENTITY_PROFILE";
export const RECEIVE_IDENTITY_PROFILE = "RECEIVE_IDENTITY_PROFILE";
